export function htmlContainsFootnotes(html: string) {
  throw new Error('htmlContainsFootnotes called on the client!');
}

export function cheerioParse() {
  throw new Error('cheerioParse called on the client!');
}
